import {del, get, patch, post, put} from './http'

/**
 * 添加素材分组
 * @param params
 */
export const addSourceGroup = (params) => post('goodsmanual/material/group', params)

/**
 * 编辑素材分组
 * @param id
 * @param params
 */
export const editSourceGroup = (id, params) => patch('goodsmanual/material/group' + id, params)

/**
 * 获取分组列表
 * @param params
 */
export const getSourceGroupList = (params) => get('goodsmanual/folder/group/list', params)

/**
 * 批量编辑分组
 * @param params
 * @returns {*}
 */
export const muliteEditSourceGroup = (params) => put('goodsmanual/material/group/batch', params)

/**
 * 删除分组
 * @param params
 */
export const delSourceGroup = (params) => del('goodsmanual/material/group', params)

/************************ 最新图标***************************/

/**
 * 获取系统图标
 * @param params
 */
export const getSysPicLists = (params) => get('goodsmanual/icon/system/list', params)

/**
 * 获取自定义图标
 * @param params
 */
export const getIconLists = (params) => get('goodsmanual/icon/ent/list', params)

/**
 * 新增图标素材
 * @param params
 */
export const addNewIcon = (params) => post('goodsmanual/icon/ent', params)

/************************ 最新图片素材 ***************************/

/**
 * 新增图片素材
 * @param params
 */
export const addNewPic = (params) => post('goodsmanual/material/img/ent', params)

/**
 * 获取图片列表
 * @param params
 */
export const getPicLists = (params) => get('goodsmanual/material/img/ent/list', params)

/**
 * 删除图片素材
 * @param params
 */
export const delPic = (params) => del('goodsmanual/material/img/ent', params)

/**
 * 图片详情
 * @param params
 */
export const getPicDetail = (id, params) => get('goodsmanual/material/img/ent/' + id, params)

/**
 * 编辑图片
 * @param id
 * @param params
 */
export const editPic = (id, params) => put('goodsmanual/material/img/ent/' + id, params)

/**
 * 新建图片分类
 * @param params
 */
export const addCategory = (params) => post('goodsmanual/category', params)

/**
 * 修改图片分类
 * @param id
 * @param params
 */
export const redactCategory = (id, params) => put('goodsmanual/category/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delCategory = (params) => del('goodsmanual/category', params)

/**
 * 获取图片分类列表
 * @param params
 */
export const getCategoryLists = (params) => get('goodsmanual/category/ent/list', params)

/**
 * 新建图片分组
 * @param params
 */
export const addGroup = (params) => post('goodsmanual/group', params)

/**
 * 修改图片分组
 * @param id
 * @param params
 */
export const redactGroup = (id, params) => put('goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delGroup = (params) => del('goodsmanual/group', params)

/**
 * 获取图片分组列表
 * @param params
 */
export const getGroupLists = (params) => get('goodsmanual/group/list', params)


/**
 *分类排序
 * @param params
 */
export const sortClassType = params => put('goodsmanual/category/sort', params)
/**
 *分组排序
 * @param params
 */
export const sortGroupType = params => put('goodsmanual/group/sort', params)


/************************ 视频素材 ***************************/

/**
 * 添加视频素材
 * @param params
 */
export const addVideo = (params) => post('/goodsmanual/material/video/ent', params)

/**
 * 编辑视频
 * @param id
 * @param params
 */
export const editVideo = (id, params) => put('/goodsmanual/material/video/ent/' + id, params)

/**
 * 获取视频详情
 * @param id
 */
export const getVideoDetail = (id, params) => get('/goodsmanual/material/video/ent/' + id, params)

/**
 * 删除视频素材
 * @param params
 */
export const delVideo = (params) => del('/goodsmanual/material/video/ent', params)

/**
 * 获取视频列表
 * @param params
 */
export const getVideoList = (params) => get('/goodsmanual/material/video/ent/list', params)

/**
 * 添加视频分类
 * @param params
 */
export const addVideoCategory = (params) => post('/goodsmanual/category', params)

/**
 * 编辑视频分类
 * @param id
 * @param params
 */
export const editVideoCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 获取视频分类详情
 * @param id
 */
export const getVideoCategoryDetail = (id) => get('goodsmanual/video/category/ent/' + id, {})

/**
 * 获取视频分类别表
 */
export const getVideoCategoryList = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 删除视频分类
 * @param params
 */
export const delVideoCategory = (params) => del('/goodsmanual/category', params)

/**
 * 添加视频分组
 * @param params
 */
export const addVideoGroup = (params) => post('/goodsmanual/group', params)

/**
 * 编辑视频分组
 * @param id
 * @param params
 */
export const editVideoGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 获取视频分组详情
 * @param id
 */
export const getVideoGroupDetail = (id) => get('goodsmanual/video/group/ent/' + id, {})

/**
 * 获取视频分组列表
 */
export const getVideoGroupList = (params) => get('/goodsmanual/group/list', params)

/**
 * 删除视频分组
 * @param params
 */
export const delVideoGroup = (params) => del('/goodsmanual/group', params)

/************************ 文件素材 ***************************/

/**
 * 新增文件素材
 * @param params
 */
export const addFile = (params) => post('goodsmanual/material/file', params)

/**
 * 删除文件素材
 * @param params
 */
export const delFile = (params) => del('goodsmanual/document', params)

/**
 * 获取文件列表
 * @param params
 */
export const getFileList = (params) => get('goodsmanual/document/ent/list', params)

/**
 * 编辑文件信息
 * @param id
 * @param params
 */
export const editFile = (id, params) => put('goodsmanual/document/' + id, params)

/**
 * 迁移文件(到分组)
 * @param params
 */
export const tansferFile = (params) => put('goodsmanual/material/folder/move', params)

/************************ 文件夹 ***************************/

/**
 * 添加文件夹
 * @param params
 */
export const addFolder = (params) => post('goodsmanual/folder', params)

/**
 * 文件夹列表
 * @param params
 */
export const getfolderList = (params) => get('goodsmanual/folder/ent/list', params)

/**
 * 编辑文件夹
 * @param id
 * @param params
 */
export const editFolder = (id, params) => put('goodsmanual/folder/' + id, params)

/**
 * 批量删除文件夹
 * @param params
 */
export const delFolder = (params) => del('goodsmanual/folder', params)

/**
 * 删除文件夹分组
 * @param params
 */
export const delFolderGroup = (params) => del('/goodsmanual/folder/relation', params)

/**
 * 获取文件夹详情
 * @param id
 */
export const getFolderDetail = (id) => get('goodsmanual/folder/' + id, {})

/**
 * 迁移文件到文件夹
 * @param params
 */
export const tansferToFloder = (params) => put('goodsmanual/document/move', params)

/************************ 收藏 ***************************/

/**
 * 获取收藏列表
 */
export const getCollectList = (params) => get('goodsmanual/user/collect/list', params)

/**
 * 收藏文件
 * @param params
 */
export const collectFile = (params) => post('goodsmanual/user/collect', params)

/**
 * 取消收藏
 * @param params
 */
export const cancelCollect = (params) => put('goodsmanual/user/collect/cancel', params)

/**
 * 获取素材单页列表数据
 * @param params
 */
export const getWebPageList = (params) => get('goodsmanual/decorate/page/ent/single/list', params)

/************************ 文章素材 ***************************/

/**
 *  渲染文章素材
 * @param params
 */
export const getArticle = (params) => get('/goodsmanual/article/ent/list', params)

/**
 * 添加文章素材
 * @param params
 */
export const AddArticle = (params) => post('/goodsmanual/article/ent', params)

/**
 * 编辑文章
 * @param id
 * @param params
 */
export const editArticle = (id, params) => put('/goodsmanual/article/ent/' + id, params)

/**
 * 文章详情
 * @param params
 */
export const getArticleDetail = (id, params) => get('/goodsmanual/article/ent/' + id, params)

/**
 * 删除文章
 * @param params
 */
export const delArticle = (params) => del('/goodsmanual/article/ent', params)

/**
 * 渲染文章分类列表
 * @param params
 */
export const getArticleCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染文章分组列表
 * @param params
 */
export const getArticleGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加文章分类
 * @param params
 */
export const addArticleCategory = (params) => post('/goodsmanual/category', params)

/**
 * 添加文章分组
 * @param params
 */
export const addArticleGroup = (params) => post('/goodsmanual/group', params)

/**
 * 修改文章分类
 * @param id
 * @param params
 */
export const redactArticleCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改文章分组
 * @param id
 * @param params
 */
export const redactArticleGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delArticleCategory = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delArticleGroup = (params) => del('/goodsmanual/group', params)

/************************ 商品素材 ***************************/

/**
 * 获取商品列表
 * @param params
 */
export const getGoods = (params) => get('/goodsmanual/goods/ent/list', params)

/**
 * 渲染商品分类
 * @param params
 */
export const getGoodsCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染商品分组
 * @param params
 */
export const getGoodsGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加分类
 * @param params
 */
export const addGoodsCategory = (params) => post('/goodsmanual/category', params)

/**
 * 添加分组
 * @param params
 */
export const addGoodsGroup = (params) => post('/goodsmanual/group', params)

/**
 * 修改分类
 * @param id
 * @param params
 */
export const redactGoodsCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改分组
 * @param id
 * @param params
 */
export const redactGoodsGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delGoodsCategory = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delGoodsGroup = (params) => del('goodsmanual/group', params)

/**
 * 新增商品
 * @param params
 */
export const addGoods = (params) => post('goodsmanual/goods', params)

/**
 * 编辑商品
 * @param id
 * @param params
 */
export const editGoods = (id, params) => put('goodsmanual/goods/' + id, params)

/**
 * 编辑商品
 * @param id
 * @param params
 */
export const editItemGoods = (id, params) => patch('goodsmanual/goods/base/' + id, params)
/**
 * 获取商品详情
 * @param id
 */
export const getGoodDetail = (id) => get('goodsmanual/goods/ent/' + id, {})

/**
 * 删除商品
 * @param params
 */
export const delGood = (params) => del('goodsmanual/goods', params)

/************************ 海报素材 ***************************/

/**
 *  渲染海报素材
 * @param params
 */
export const getPoster = (params) => get('/goodsmanual/poster/ent/list', params)

/**
 * 添加海报素材
 * @param params
 */
export const getAddPoster = (params) => post('/goodsmanual/poster', params)

/**
 * 编辑海报
 * @param id
 * @param params
 */
export const editPoster = (id, params) => put('/goodsmanual/poster/' + id, params)

/**
 * 海报详情
 * @param params
 */
export const getPosterDetail = (id, params) => get('/goodsmanual/poster/ent/' + id, params)

/**
 * 删除海报
 * @param params
 */
export const delPoster = (params) => del('/goodsmanual/poster', params)

/**
 * 渲染海报分类列表
 * @param params
 */
export const getPosterCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染分组列表
 * @param params
 */
export const getPosterGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加分类
 * @param params
 */
export const addPosterCategory = (params) => post('/goodsmanual/category', params)

/**
 * 添加分组
 * @param params
 */
export const addPosterGroup = (params) => post('/goodsmanual/group', params)

/**
 * 修改分类
 * @param id
 * @param params
 */
export const redactPosterCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改分组
 * @param id
 * @param params
 */
export const redactPosterGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delPosterCategory = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delPosterGroup = (params) => del('/goodsmanual/group', params)

/************************ 名片素材 ***************************/

/**
 *  渲染海报名片素材
 * @param params
 */
export const getBuscard = (params) => get('/goodsmanual/buscard/ent/list', params)

/**
 * 添加名片素材
 * @param params
 */
export const addBuscard = (params) => post('/goodsmanual/buscard', params)

/**
 * 编辑名片
 * @param id
 * @param params
 */
export const editBuscard = (id, params) => put('/goodsmanual/buscard/' + id, params)

/**
 * 名片详情
 * @param params
 */
export const getBuscardDetail = (id, params) => get('/goodsmanual/buscard/ent/' + id, params)

/**
 * 删除名片
 * @param params
 */
export const delBuscard = (params) => del('/goodsmanual/buscard', params)

/**
 * 渲染海报分类列表
 * @param params
 */
export const getBuscardCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染分组列表
 * @param params
 */
export const getBuscardGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加分类
 * @param params
 */
export const addBuscardCategory = (params) => post('/goodsmanual/category', params)

/**
 * 添加分组
 * @param params
 */
export const addBuscardGroup = (params) => post('/goodsmanual/group', params)

/**
 * 修改分类
 * @param id
 * @param params
 */
export const redactBuscardCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改分组
 * @param id
 * @param params
 */
export const redactBuscardGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delBuscardCategory = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delBuscardGroup = (params) => del('/goodsmanual/group', params)

/************************ 手册素材 ***************************/

/**
 *  渲染海手册素材
 * @param params
 */
export const getHandBook = (params) => get('/goodsmanual/handbook/ent/list', params)

/**
 * 添加手册素材
 * @param params
 */
export const getAddHandBook = (params) => post('/goodsmanual/handbook', params)

/**
 * 编辑手册
 * @param id
 * @param params
 */
export const editHandBook = (id, params) => patch('/goodsmanual/handbook/' + id, params)

/**
 * 手册详情
 * @param params
 */
export const getHandBookDetail = (id, params) => get('/goodsmanual/handbook/ent/' + id, params)

/**
 * 删除手册
 * @param params
 */
export const delHandBook = (params) => del('/goodsmanual/handbook', params)

/**
 * 渲染分类列表
 * @param params
 */
export const getHandBookCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染分组列表
 * @param params
 */
export const getHandBookGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加分类
 * @param params
 */
export const addHandBookCategory = (params) => post('/goodsmanual/category', params)

/**
 * 添加分组
 * @param params
 */
export const addHandBookGroup = (params) => post('/goodsmanual/group', params)

/**
 * 修改分类
 * @param id
 * @param params
 */
export const redactHandBookCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改分组
 * @param id
 * @param params
 */
export const redactHandBookGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delHandBookCategory = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delHandBookGroup = (params) => del('/goodsmanual/group', params)

/************************ 文档素材 ***************************/

/**
 *  渲染文档素材
 * @param params
 */
export const getDocument = (params) => get('/goodsmanual/material/document/ent/list', params)

/**
 * 添加文档素材
 * @param params
 */
export const AddDocument = (params) => post('/goodsmanual/material/document/ent', params)

/**
 * 编辑文档
 * @param id
 * @param params
 */
export const editDocument = (id, params) => put('/goodsmanual/material/document/ent/' + id, params)

/**
 * 文档详情
 * @param params
 */
export const getDocumentDetail = (id, params) => get('/goodsmanual/material/document/app/' + id, params)

/**
 * 删除文档
 * @param params
 */
export const delDocument = (params) => del('/goodsmanual/material/document/ent', params)

/**
 * 渲染分类列表
 * @param params
 */
export const getDocumentCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染分组列表
 * @param params
 */
export const getDocumentGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加分类
 * @param params
 */
export const addDocumentCategory = (params) => post('/goodsmanual/category', params)

/**
 * 添加分组
 * @param params
 */
export const addDocumentGroup = (params) => post('/goodsmanual/group', params)

/**
 * 修改分类
 * @param id
 * @param params
 */
export const redactDocumentCategory = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改分组
 * @param id
 * @param params
 */
export const redactDocumentGroup = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delDocumentCategory = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delDocumentGroup = (params) => del('/goodsmanual/group', params)

/************************ 素材导航***************************/

/**
 *  渲染导航素材
 * @param params
 */
export const getLocation = (params) => get('/goodsmanual/material/location/ent/list', params)

/**
 * 添加文档素材
 * @param params
 */
export const AddLocation = (params) => post('/goodsmanual/material/location/ent', params)

/**
 * 编辑导航
 * @param id
 * @param params
 */
export const editLocation = (id, params) => put('/goodsmanual/material/location/ent/' + id, params)

/**
 * 导航详情
 * @param params
 */
export const getLocationDetail = (id, params) => get('/goodsmanual/material/location/ent/' + id, params)

/**
 * 删除导航
 * @param params
 */
export const delLocation = (params) => del('/goodsmanual/material/location/ent', params)

/************************ 素材渲染***************************/

/**
 *  渲染导航素材
 * @param params
 */
export const getBbs = (params) => get('/goodsmanual/bbs/ent/list', params)

/**
 * 添加文档素材
 * @param params
 */
export const AddBbs = (params) => post('/goodsmanual/bbs', params)

/**
 * 导航详情
 * @param params
 */
export const getBbsDetail = (id, params) => get('/goodsmanual/bbs/' + id, params)

/**
 * 删除渲染
 * @param params
 */
export const delBbs = (id, params) => del('/goodsmanual/bbs/ent/' + id, params)

/************************ 素材渲染***************************/

/**
 *  渲染导航素材
 * @param params
 */
export const getComment = (params) => get('goodsmanual/comment/list', params)

// /**
//  * 添加文档素材
//  * @param params
//  */
// export const AddBbs = (params) => post('/goodsmanual/bbs', params)
//
// /**
//  * 导航详情
//  * @param params
//  */
// export const getBbsDetail = (id, params) => get('/goodsmanual/bbs/' + id, params)
//
/**
 * 删除渲染
 * @param params
 */
export const delComment = (id, params) => del('goodsmanual/comment/ent/' + id, params)

/************************ 素材分类分组 ***************************/

/**
 * 渲染分类列表
 * @param params
 */
export const getCategory = (params) => get('/goodsmanual/category/ent/list', params)

/**
 * 渲染分组列表
 * @param params
 */
export const getGroup = (params) => get('/goodsmanual/group/list', params)

/**
 * 添加分类
 * @param params
 */
export const addCategories = (params) => post('/goodsmanual/category', params)

/**
 * 添加分组
 * @param params
 */
export const postAddGroupes = (params) => post('/goodsmanual/group', params)

/**
 * 修改分类
 * @param id
 * @param params
 */
export const redactCategorisy = (id, params) => put('/goodsmanual/category/' + id, params)

/**
 * 修改分组
 * @param id
 * @param params
 */
export const redactGroupes = (id, params) => put('/goodsmanual/group/' + id, params)

/**
 * 删除分类
 * @param params
 */
export const delCategories = (params) => del('/goodsmanual/category', params)

/**
 * 删除分组
 * @param params
 */
export const delGroupes = (params) => del('/goodsmanual/group', params)

/************************ PDF转图片 ***************************/

/**
 * Pdf上传转化图片接口
 * @param params
 */
export const pdfToPic = (params) => put('goodsmanual/convert/pdf', params)

/**
 * 获取某个uploadId分解成的图片组
 * @param uploadId
 */
export const getPdfToPisList = (uploadId) => get('goodsmanual/task/' + uploadId, {})

